import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const LogoOneLine = withDefaultIconProps(
  {
    height: 48,
    width: (48 * 1584) / 576,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 1584 576">
      <Path
        d="M140.12,358.15h-41.52v-194.46h59.32c42.04,0,71.7,22.95,71.7,61.38s-29.66,61.12-71.7,61.12h-17.8v71.95ZM140.12,252.16h17.02c18.31,0,31.46-9.03,31.46-27.08s-13.15-27.34-31.46-27.34h-17.02v54.42Z"
        fill={color}
      />
      <Path
        d="M365.02,228.69v129.47h-39.2v-15.47c-7.74,10.06-22.44,18.57-40.23,18.57-35.33,0-63.96-29.14-63.96-67.83s28.63-67.83,63.96-67.83c17.8,0,32.5,8.51,40.23,18.57v-15.47h39.2ZM293.83,327.46c18.83,0,33.01-14.7,33.01-34.04s-14.18-34.04-33.01-34.04-33.27,14.7-33.27,34.04,14.18,34.04,33.27,34.04Z"
        fill={color}
      />
      <Path
        d="M461.65,267.89c-4.64-1.55-8.77-2.06-13.67-2.06-18.31,0-31.21,10.83-31.21,30.17v62.16h-39.2v-129.47h39.2v18.57c6.45-11.35,19.34-20.89,35.33-20.89,3.87,0,6.7.77,9.54,1.55v39.98Z"
        fill={color}
      />
      <Path d="M473.33,186.65h39.2v42.04h32.5v40.24h-32.5v89.23h-39.2v-171.51Z" fill={color} />
      <Path
        d="M694.88,228.69v129.47h-39.2v-15.47c-7.74,10.06-22.44,18.57-40.23,18.57-35.33,0-63.96-29.14-63.96-67.83s28.63-67.83,63.96-67.83c17.79,0,32.5,8.51,40.23,18.57v-15.47h39.2ZM623.7,327.46c18.83,0,33.01-14.7,33.01-34.04s-14.19-34.04-33.01-34.04-33.27,14.7-33.27,34.04,14.18,34.04,33.27,34.04Z"
        fill={color}
      />
      <Path
        d="M777.67,425.72c-36.36,0-67.05-21.92-68.6-57.25h38.68c1.55,15.73,13.67,25.28,30.43,25.28,18.31,0,32.24-11.86,32.24-34.56v-16.51c-7.74,10.06-22.44,18.57-40.23,18.57-35.33,0-63.96-29.14-63.96-67.83s28.63-67.83,63.96-67.83c17.79,0,32.5,8.51,40.23,18.57v-15.47h39.2v128.95c0,42.04-33.79,68.09-71.95,68.09ZM778.44,327.46c18.83,0,33.01-14.7,33.01-34.04s-14.19-34.04-33.01-34.04-33.27,14.7-33.27,34.04,14.18,34.04,33.27,34.04Z"
        fill={color}
      />
      <Path
        d="M960.01,310.44l27.6,19.09c-12.38,20.37-33.79,31.72-58.8,31.72-36.62,0-67.83-28.89-67.83-67.83s31.21-67.83,66.8-67.83c42.3,0,67.31,33.53,64.73,78.4h-95.17c3.87,15.99,16.51,25.28,31.46,25.28s23.73-7.22,31.21-18.83ZM898.63,279.49h56.74c-1.81-11.09-10.57-22.18-27.34-22.18-13.15,0-24.76,8.25-29.4,22.18Z"
        fill={color}
      />
      <Path
        d="M1100.95,322.04c19.08,0,35.33-7.48,46.16-18.05v46.42c-13.93,7.22-30.17,10.83-46.94,10.83-56.22,0-101.61-45.13-101.61-100.32s45.39-100.32,101.61-100.32c16.76,0,33.01,3.87,46.94,10.83v46.42c-10.83-10.57-27.08-18.05-46.16-18.05-34.82,0-60.87,26.31-60.87,61.12s26.05,61.12,60.87,61.12Z"
        fill={color}
      />
      <Path d="M1199.12,150.28v207.87h-39.2v-207.87h39.2Z" fill={color} />
      <Path
        d="M1291.98,303.54v-74.79h39.2v76.08c0,33.27-25.27,56.48-60.09,56.48s-60.35-23.21-60.35-56.74v-75.82h39.2v74.79c0,15.22,7.74,24.24,21.15,24.24s20.89-9.03,20.89-24.24Z"
        fill={color}
      />
      <Path
        d="M1381.47,244.15c7.48-10.06,22.18-18.57,39.98-18.57,35.33,0,63.96,29.14,63.96,67.83s-28.63,67.83-63.96,67.83c-17.8,0-32.5-8.51-39.98-18.57v15.47h-39.2v-207.87h39.2v93.88ZM1413.45,259.37c-19.08,0-33.27,14.7-33.27,34.04s14.18,34.04,33.27,34.04,33.01-14.7,33.01-34.04-14.18-34.04-33.01-34.04Z"
        fill={color}
      />
    </Svg>
  ),
);
